import VxePagerComponent from './src/pager';
import { dynamicApp } from '../dynamics';
export var VxePager = Object.assign(VxePagerComponent, {
    install: function (app) {
        app.component(VxePagerComponent.name, VxePagerComponent);
    }
});
export var Pager = VxePager;
dynamicApp.component(VxePagerComponent.name, VxePagerComponent);
export default VxePager;
